/**
 * Cabeçalho padrão das páginas CRUD (ecossistema Grupo Laçador).
 * Mostra chip + título + subtítulo e um slot `actions` (ex.: "Novo", Excel).
 * A DATA/HORA e o usuário ficam no header global (MasterApp), para não duplicar.
 */
export default function PageHeader({ chip, title, user = "Master", subtitle, actions }) {
  return (
    <div className="flex items-end justify-between gap-3 flex-wrap" data-testid="page-header">
      <div className="min-w-0">
        {chip && (
          <div className="text-[10px] uppercase tracking-[0.2em] text-[color:var(--brand-red)] font-bold mb-1.5">{chip}</div>
        )}
        <h1 className="font-display font-black uppercase text-3xl md:text-4xl leading-none text-[color:var(--ink)]">{title}</h1>
        {subtitle && <p className="text-sm text-neutral-500 mt-1.5">{subtitle}</p>}
      </div>

      {actions && <div className="flex items-center gap-2 flex-wrap shrink-0">{actions}</div>}
    </div>
  );
}
